import React from 'react'
// libs
import { useAui } from '@assistant-ui/react'
// views
import { TemplateChip, TemplatesBarWrapper } from './views'

interface Props {
  prompts: string[]
}

const SuggestedPrompts: React.FC<Props> = ({ prompts }) => {
  const aui: any = useAui()

  const handleTemplateClick = (text: string) => {
    aui.composer().setText(text)
    aui.composer().send()
  }

  if (!prompts.length) {
    return null
  }

  return (
    <TemplatesBarWrapper>
      {prompts.map((prompt, idx) => (
        <TemplateChip key={idx} type='button' onClick={() => handleTemplateClick(prompt)}>
          {prompt}
        </TemplateChip>
      ))}
    </TemplatesBarWrapper>
  )
}

export default SuggestedPrompts
